<div class="container-main">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-contacto></app-contacto>
    <app-footer></app-footer>
</div>

